var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('c-source-page',{attrs:{"columns":_vm.columns,"filter":_vm.filter,"table":_vm.table,"pagination":_vm.pagination,"resource":"users","exportExcelURL":"/users/resource.xlsx"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }